module.exports = __webpack_public_path__ + "static/media/mascot.8637edc6.svg";